export default __webpack_public_path__ + "static/media/verdana.7eaabf22.woff";